import { CheckCircleIcon, MinusCircleIcon } from '../../../icons';
import validatePassword from '../../../lib/validation/passwordValidation';
import { cx } from '../../../utils/cx';

interface IPasswordChecklistProps {
  /** Current password value to validate */
  password: string;
  /** Confirm password value — when provided, shows a "Passwords match" checklist item */
  confirmPassword?: string;
  /** Server-side error (e.g. "too common") shown as an additional failed item */
  serverError?: string;
}

const PasswordChecklist = ({ password, confirmPassword, serverError }: IPasswordChecklistProps) => {
  const { rules, maxLengthError } = validatePassword(password);

  const showMatchItem = confirmPassword !== undefined;
  const passwordsMatch =
    showMatchItem && password.length > 0 && confirmPassword.length > 0 && password === confirmPassword;

  return (
    <ul className="flex flex-col gap-1" role="list">
      {rules.map((rule) => (
        <li key={rule.id} className="flex items-center gap-2">
          {rule.met ? (
            <CheckCircleIcon className={cx('text-fg-success-secondary size-4 shrink-0')} />
          ) : (
            <MinusCircleIcon className={cx('text-fg-quaternary size-4 shrink-0')} />
          )}
          <span className={cx('text-sm', rule.met ? 'text-success-primary' : 'text-tertiary')}>{rule.label}</span>
        </li>
      ))}

      {showMatchItem && (
        <li className="flex items-center gap-2">
          {passwordsMatch ? (
            <CheckCircleIcon className="text-fg-success-secondary size-4 shrink-0" />
          ) : (
            <MinusCircleIcon className="text-fg-quaternary size-4 shrink-0" />
          )}
          <span className={cx('text-sm', passwordsMatch ? 'text-success-primary' : 'text-tertiary')}>
            Passwords match
          </span>
        </li>
      )}

      {maxLengthError && (
        <li className="flex items-center gap-2">
          <MinusCircleIcon className="text-fg-error-secondary size-4 shrink-0" />
          <span className="text-error-primary text-sm">{maxLengthError}</span>
        </li>
      )}

      {serverError && (
        <li className="flex items-center gap-2">
          <MinusCircleIcon className="text-fg-error-secondary size-4 shrink-0" />
          <span className="text-error-primary text-sm">{serverError}</span>
        </li>
      )}
    </ul>
  );
};

PasswordChecklist.displayName = 'PasswordChecklist';

export default PasswordChecklist;
